module.exports = __webpack_public_path__ + "img/Group-543.f0b4a425.svg";